import {
  CreateUserInvite,
  DeleteUserInvite,
  UserInvites,
  Users,
  UpdateUser,
  DeactivateUser,
  ReactivateUser,
  DeleteUser,
  ResendPasswordSetupEmail,
} from '@/graphql';
import { apolloClient } from '@/plugins/apollo';
import { UserInvite, Researcher } from '@/models';

const actions = {
  // ==================== User Invite Actions ====================
  async fetchUserInvites() {
    const response = await apolloClient.query({
      query: UserInvites,
      fetchPolicy: 'network-only',
    });
    return response.data.userInvites.map(
      (invite) => new UserInvite(invite)
    );
  },
  async createUserInvite(context, invite) {
    const response = await apolloClient.mutate({
      mutation: CreateUserInvite,
      variables: { invite },
    });
    return response.data.createUserInvite
      ? new UserInvite(response.data.createUserInvite)
      : null;
  },
  async deleteUserInvite(context, inviteId) {
    await apolloClient.mutate({
      mutation: DeleteUserInvite,
      variables: { id: inviteId },
    });
  },

  // ==================== User Management Actions ====================
  async fetchUsers(context, searchInput = null) {
    const response = await apolloClient.query({
      query: Users,
      variables: { searchInput },
      fetchPolicy: 'network-only',
    });
    return response.data.users.map((user) => new Researcher(user));
  },

  async updateUser(context, input) {
    const response = await apolloClient.mutate({
      mutation: UpdateUser,
      variables: { input },
    });
    return response.data.updateUser
      ? new Researcher(response.data.updateUser)
      : null;
  },

  async deactivateUser(context, id) {
    const response = await apolloClient.mutate({
      mutation: DeactivateUser,
      variables: { id },
    });
    return response.data.deactivateUser
      ? new Researcher(response.data.deactivateUser)
      : null;
  },

  async reactivateUser(context, id) {
    const response = await apolloClient.mutate({
      mutation: ReactivateUser,
      variables: { id },
    });
    return response.data.reactivateUser
      ? new Researcher(response.data.reactivateUser)
      : null;
  },

  async deleteUser(context, id) {
    await apolloClient.mutate({
      mutation: DeleteUser,
      variables: { id },
    });
  },

  async resendPasswordSetupEmail(context, id) {
    const response = await apolloClient.mutate({
      mutation: ResendPasswordSetupEmail,
      variables: { id },
    });
    return response.data.resendPasswordSetupEmail;
  },
};

const state = {};

const mutations = {};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
};
